export const SERVICE_CODE = 'PENNYLANE' + '_SERVICE';
